import React from 'react';
import { RefreshCw, AlertCircle, CheckCircle } from 'lucide-react';

/**
 * Visual indicator for retry operations
 * Shows current retry attempt, delay, and status
 */
const RetryIndicator = ({ 
  isRetrying = false, 
  attempt = 0, 
  maxRetries = 3, 
  delay = 0,
  error = null,
  success = false,
  className = ''
}) => {
  if (!isRetrying && !error && !success) return null;

  return (
    <div className={`flex items-center gap-2 text-sm ${className}`}>
      {isRetrying && (
        <>
          <RefreshCw className="w-4 h-4 animate-spin text-blue-600" />
          <span className="text-gray-700">
            Retrying... ({attempt}/{maxRetries})
            {delay > 0 && (
              <span className="text-gray-500 ml-1">
                - waiting {Math.round(delay / 1000)}s
              </span>
            )}
          </span>
        </>
      )}
      
      {error && !isRetrying && (
        <>
          <AlertCircle className="w-4 h-4 text-red-600" />
          <span className="text-red-700">
            Request failed after {attempt} attempts
          </span>
        </>
      )}
      
      {success && !isRetrying && (
        <>
          <CheckCircle className="w-4 h-4 text-green-600" />
          <span className="text-green-700">
            Request successful
            {attempt > 0 && ` (after ${attempt} retries)`}
          </span>
        </>
      )}
    </div>
  );
};

export default RetryIndicator;